export const DEFAULT_RANGE_START = 0;
export const DEFAULT_RANGE_END = 100;

export default class ProgressBarRange {

  // -----------------------//
  // Public Static Methods //
  // -----------------------//

  static toNumber(value, fallback) {
    if (value === null || value === undefined || value === "") {
      return fallback;
    }
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  static percentOfRange(value, rangeStart, rangeEnd) {
    const low = ProgressBarRange.toNumber(rangeStart, DEFAULT_RANGE_START);
    const high = ProgressBarRange.toNumber(rangeEnd, DEFAULT_RANGE_END);
    if (high <= low) {
      return 0;
    }
    const current = ProgressBarRange.toNumber(value, low);
    const percent = (current - low) / (high - low) * 100;
    return Math.max(0, Math.min(100, percent));
  }
}
